import { Tooltip, Typography } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import { defaultFulfillmentCenterTypeFilters } from 'src/features/fulfillmentCenterFilters'
import { PrinterData } from 'src/features/settings/printers-management/PrintersManagementTypes'
import Button from 'src/components/Button'
import * as S from './PrinterInfo.styles'
import { limitCharacters } from 'src/utils/formatString'
import {
  DarkBlue, DarkBlueHover, Red, DarkRedHover,
} from 'src/assets/colors'
import Modal from 'src/components/Modal'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { selectFulfillmentCenters } from 'src/features/selector'
import { actions as appActions } from 'src/features/state'
import { useSelector } from 'src/utils/store'
import RemotePrintersList from 'src/features/settings/printers-management/components/RemotePrintersList'
import './PrinterInfo.css'
import { actions } from '../../FractionState'

export const PrinterInfo = () => {
  const DEVICE_NAME_MAX_LENGTH = 50

  const {
    register, watch, reset,
  } = useForm<{ fulfillmentCenterId: number }>()

  const dispatch = useDispatch()

  const [printerInfo, setPrinterInfo] = useState<PrinterData | undefined>(undefined)

  const [showModal, setShowModal] = useState(false)

  const fulfillmentCenters = useSelector(selectFulfillmentCenters)

  useEffect(() => {
    if (!fulfillmentCenters || fulfillmentCenters.length === 0) {
      dispatch(appActions.getAvailableFulfillmentCenters(defaultFulfillmentCenterTypeFilters))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  const fulfillmentCenterId = watch('fulfillmentCenterId')

  const fulfillmentCenterOptions = useMemo(() => fulfillmentCenters.map((fulfillmentCenter) => ({
    id: fulfillmentCenter.id,
    description: fulfillmentCenter.name,
  })), [fulfillmentCenters])

  useEffect(() => {
    const printerInfoData = localStorage.getItem('printerInfo')
    setPrinterInfo(printerInfoData && JSON.parse(printerInfoData))
  }, [])

  useEffect(() => {
    reset()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal])

  const getDeviceName = () => {
    if (printerInfo?.deviceName) {
      return limitCharacters(printerInfo.deviceName, DEVICE_NAME_MAX_LENGTH)
    }
    return 'não selecionada'
  }

  const removeSelectedPrinter = () => {
    dispatch(actions.clearField('isRemotePrinterConnected'))
    dispatch(actions.clearField('fractionTag'))
    setPrinterInfo(undefined)
  }

  const handleRemoveSelectedPrinter = () => {
    localStorage.removeItem('printerInfo')
    removeSelectedPrinter()
  }

  const handleCloseModal = () => {
    const printerInfoData = localStorage.getItem('printerInfo')
    if (printerInfoData) {
      setPrinterInfo(JSON.parse(printerInfoData))
      dispatch(actions.checkRemotePrinterStatus())
    } else {
      removeSelectedPrinter()
    }
    setShowModal(false)
  }

  return (
    <>
      <S.Container>
        <Tooltip
          title={printerInfo?.deviceName || ''}
          placement='top'
          disableHoverListener={!!printerInfo?.deviceName && printerInfo?.deviceName.length <= DEVICE_NAME_MAX_LENGTH}
          arrow
        >
          <Typography variant='body1'>Impressora: {getDeviceName()}</Typography>
        </Tooltip>
        {printerInfo && (
          <S.CustomRemovePrinterButton
            id='remove-selected-printer'
            name='remove-selected-printer'
            data-testid='remove-selected-printer-test-id'
            onClick={handleRemoveSelectedPrinter}
          >
            X
          </S.CustomRemovePrinterButton>
        )}
        <Button
          text='Selecionar Impressora'
          style={{
            height: '40px',
            width: '200px',
            minWidth: '200px',
          }}
          color={printerInfo ? DarkBlue : Red}
          hoverColor={printerInfo ? DarkBlueHover : DarkRedHover}
          onClick={() => setShowModal(true)}
          testId='select-printer-button-test-id'
        />
      </S.Container>
      <Modal
        dialogClassName='custom-modal-style'
        show={showModal}
        title='Selecionar Impressora'
        closeButtonAction={handleCloseModal}
        centered
        body={(
          <S.ModalContainer>
            <S.CustomSelect
              name='fulfillmentCenterId'
              inputProps={{
                ...register(
                  'fulfillmentCenterId',
                ),
                'data-testid': 'fulfillment-center-select-test-id',
              }}
              autoComplete='off'
              id='fulfillmentCenterId'
              label='Selecione um FC'
              variant='outlined'
              options={fulfillmentCenterOptions}
              optionNone={false}
              type='text'
              fullWidth={false}
              autoFocus
              maxHeight='600px'
              dataTestId='fulfillment-center-select-test-id'
            />
            <S.ComponentContainer>
              {fulfillmentCenterId ? (
                <RemotePrintersList fulfillmentCenterId={fulfillmentCenterId} height='50vh' characterLimitNumber={DEVICE_NAME_MAX_LENGTH} />
              ) : (
                <Typography variant='body1'>Selecione um fulfillment center para buscar as impressoras disponíveis</Typography>
              )}
            </S.ComponentContainer>
            <S.ButtonContainer>
              <Button
                text='Fechar'
                onClick={handleCloseModal}
                testId='close-button-test-id'
                style={{ width: '12rem', marginTop: '12px' }}
              />
            </S.ButtonContainer>
          </S.ModalContainer>
        )}
        testId='modal-select-printer-test-id'
      />
    </>
  )
}
